import { render, staticRenderFns } from "./StorySettings.vue?vue&type=template&id=6c016ae1"
import script from "./StorySettings.vue?vue&type=script&lang=js"
export * from "./StorySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports